import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';

const buttonSx = {
  minWidth: 56,
  p: 0.25,
  flexShrink: 0,
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 0.5,
  borderRadius: '8px',
  backgroundColor: 'transparent',
  color: '#5757b0',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: 'transparent',
    '& .ProjectHeaderButton-icon': {
      borderColor: '#5757b0',
      backgroundColor: 'rgba(87, 87, 176, 0.06)'
    },
    '& .ProjectHeaderButton-label': {
      color: '#373f8c'
    }
  },
  '&[aria-pressed="true"]': {
    color: '#373f8c',
    '& .ProjectHeaderButton-icon': {
      borderColor: '#5757b0',
      backgroundColor: 'rgba(87, 87, 176, 0.12)',
      color: '#373f8c'
    },
    '& .ProjectHeaderButton-label': {
      color: '#373f8c',
      fontWeight: 700
    }
  },
  '&.Mui-focusVisible': {
    outline: '2px solid #5757b0',
    outlineOffset: 2
  }
};

const iconBoxSx = {
  width: 40,
  height: 40,
  borderRadius: '8px',
  border: '1px solid rgba(87, 87, 176, 0.3)',
  backgroundColor: '#fff',
  color: '#5757b0',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease',
  '& .MuiSvgIcon-root': { fontSize: 20 }
};

const labelSx = {
  fontSize: '0.6875rem',
  fontWeight: 600,
  lineHeight: 1.15,
  color: 'rgba(34, 37, 52, 0.72)',
  textAlign: 'center',
  whiteSpace: 'nowrap'
};

// One native button and one tab stop for each project header control.
const ProjectHeaderButton = React.forwardRef(function ProjectHeaderButton(
  { children, tooltip, icon, 'aria-label': ariaLabel, ...props }, ref
) {
  const button = (
    <Button ref={ref} size="small" aria-label={ariaLabel || children} sx={buttonSx} {...props}>
      <Box component="span" className="ProjectHeaderButton-icon" sx={iconBoxSx}>
        {icon}
      </Box>
      {children ? (
        <Box component="span" className="ProjectHeaderButton-label" sx={labelSx}>
          {children}
        </Box>
      ) : null}
    </Button>
  );
  return (
    <Tooltip title={tooltip || children || ariaLabel} arrow placement="bottom" enterDelay={300} enterNextDelay={100}>
      {button}
    </Tooltip>
  );
});

export default ProjectHeaderButton;
